import React, { useState } from "react";
import { api } from "@/lib/api";
import { PrimaryButton, GhostButton, Card, Field, Textarea } from "@/components/Primitives";
import { toast } from "sonner";

export default function SourceVerifyModal({ open, candidate, onClose, onSaved }) {
  const [notes, setNotes] = useState("");
  const [confirmed, setConfirmed] = useState(false);
  const [busy, setBusy] = useState(false);
  if (!open) return null;

  const save = async () => {
    if (!confirmed) { toast.error("Please confirm you verified the source."); return; }
    setBusy(true);
    try {
      const r = await api.post(`/candidates/${candidate.id}/verify-source`, {
        status: "Verified", notes, confirm: true,
      });
      toast.success("Source verified — import hold cleared");
      onSaved?.(r.data);
      onClose?.();
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Verification failed");
    } finally { setBusy(false); }
  };

  return (
    <div className="fixed inset-0 bg-black/80 z-50 flex items-center justify-center p-8" data-testid="source-verify-modal">
      <Card className="max-w-xl w-full p-6">
        <div className="flex justify-between items-start mb-4">
          <div>
            <div className="text-[10px] tracking-[0.3em] uppercase text-zinc-500">Verification Hold</div>
            <h2 className="font-heading text-xl tracking-tighter">Mark Source Verified</h2>
            <p className="text-xs text-zinc-500 mt-1 truncate max-w-[420px]">{candidate?.candidate_name}</p>
          </div>
          <button onClick={onClose} className="text-zinc-500 hover:text-white" data-testid="source-verify-close">×</button>
        </div>

        <Field label="Verification Notes">
          <Textarea rows={4} value={notes} onChange={(e) => setNotes(e.target.value)}
            placeholder="What did you check on the official source? (tender number / notice ID, deadline & status, documents or accepted manual-download)"
            data-testid="source-verify-notes" />
        </Field>

        <label className="flex items-start gap-2 text-xs text-zinc-300 mt-3 cursor-pointer">
          <input type="checkbox" checked={confirmed} onChange={(e) => setConfirmed(e.target.checked)}
            data-testid="source-verify-confirm" className="mt-0.5" />
          I verified the official source/status/deadline or accepted the manual-download requirement.
        </label>

        <div className="flex justify-end gap-2 mt-5">
          <GhostButton onClick={onClose} data-testid="source-verify-cancel">Cancel</GhostButton>
          <PrimaryButton onClick={save} disabled={busy || !confirmed} data-testid="source-verify-save">
            {busy ? "Saving…" : "Mark Verified"}
          </PrimaryButton>
        </div>
      </Card>
    </div>
  );
}
